/* SENZA DIRLO - Provala: logica. I dati stanno in sd-provala.js (window.SD_PROVALA).
   Il bottone punta alla variante VERA: Horizon ignora ?Colore=&Ricamo=, quindi
   l'id della variante lo chiediamo a /products/<handle>.js e lo mettiamo in ?variant= */
window.SDProvala = function(id){
  "use strict";
  var D = window.SD_PROVALA;
  var root = document.getElementById(id);
  if(!root || !D){ return; }
  var NS = "http://www.w3.org/2000/svg";
  var ARTICOLO = { fel: "questa felpa", tso: "questa t-shirt", cap: "questo cappello" };

  var selFrase = root.querySelector("[data-frase]");
  var rigaCapo = root.querySelector("[data-capi]");
  var rigaCol  = root.querySelector("[data-colori]");
  var rigaFilo = root.querySelector("[data-fili]");
  var testo    = root.querySelector("[data-testo]");
  var gruppo   = root.querySelector("[data-gruppo]");
  var stoffa   = root.querySelector("[data-stoffa]");
  var vai      = root.querySelector("[data-vai]");
  var didasc   = root.querySelector("[data-didascalia]");
  if(!selFrase || !testo){ return; }

  var stato = { frase: D.frasi[0], capo: "fel", colore: null, filo: null };
  var cache = {}, turno = 0;

  var fam = {};
  D.frasi.forEach(function(f){ (fam[f.cat] = fam[f.cat] || []).push(f); });
  Object.keys(fam).forEach(function(cat){
    var g = document.createElement("optgroup"); g.label = cat;
    fam[cat].forEach(function(f){
      var o = document.createElement("option"); o.value = f.h; o.textContent = f.t; g.appendChild(o);
    });
    selFrase.appendChild(g);
  });

  function bottone(riga, etichetta, valore, colore, attivo, spento){
    var b = document.createElement("button");
    b.type = "button";
    b.className = "pv-scelta" + (colore ? " pv-pastiglia" : "") + (attivo ? " pv-attiva" : "") + (spento ? " pv-spenta" : "");
    if(spento){ b.disabled = true; b.title = "Questa frase non si fa sul cappello"; }
    if(colore){
      b.style.setProperty("--tinta", colore);
      b.innerHTML = "<span class='pv-bolla'></span><span class='pv-nome'></span>";
      b.querySelector(".pv-nome").textContent = etichetta;
    } else {
      b.textContent = etichetta;
    }
    riga.appendChild(b);
    return b;
  }

  function combo(){ return D.prodotti[stato.capo].combo; }

  function disegnaCapi(){
    rigaCapo.innerHTML = "";
    ["fel","tso","cap"].forEach(function(k){
      var spento = (k === "cap" && !stato.frase.cap);
      var b = bottone(rigaCapo, D.prodotti[k].nome, k, null, k === stato.capo, spento);
      if(!spento){ b.addEventListener("click", function(){ stato.capo = k; stato.colore = null; stato.filo = null; tutto(); }); }
    });
  }

  function disegnaColori(){
    var c = combo(), chiavi = Object.keys(c);
    if(chiavi.indexOf(stato.colore) < 0){ stato.colore = chiavi[0]; }
    rigaCol.innerHTML = "";
    chiavi.forEach(function(k){
      var b = bottone(rigaCol, k, k, D.capi[k] || "#999", k === stato.colore, false);
      b.addEventListener("click", function(){ stato.colore = k; stato.filo = null; tutto(); });
    });
  }

  function disegnaFili(){
    var lista = combo()[stato.colore] || [];
    if(lista.indexOf(stato.filo) < 0){ stato.filo = lista[0]; }
    rigaFilo.innerHTML = "";
    lista.forEach(function(k){
      var b = bottone(rigaFilo, k, k, D.fili[k] || "#999", k === stato.filo, false);
      b.addEventListener("click", function(){ stato.filo = k; tutto(); });
    });
  }

  function disegnaRicamo(){
    stoffa.setAttribute("fill", D.capi[stato.colore] || "#ccc");
    root.style.setProperty("--filo", D.fili[stato.filo] || "#333");
    while(testo.firstChild){ testo.removeChild(testo.firstChild); }
    var righe = stato.frase.r || [stato.frase.t], passo = 116;
    righe.forEach(function(r, i){
      var ts = document.createElementNS(NS, "tspan");
      ts.setAttribute("x", 0);
      ts.setAttribute("y", (i - (righe.length - 1) / 2) * passo);
      ts.textContent = r;
      testo.appendChild(ts);
    });
    gruppo.setAttribute("transform", "translate(320,190)");
    var b = null;
    try{ b = testo.getBBox(); }catch(e){}
    if(b && b.width){
      var s = Math.min(430 / b.width, 210 / b.height, 1.15);
      var cx = b.x + b.width / 2, cy = b.y + b.height / 2;
      gruppo.setAttribute("transform", "translate(320,190) scale(" + s.toFixed(3) + ") translate(" + (-cx).toFixed(1) + "," + (-cy).toFixed(1) + ")");
    }
  }

  function scegliVariante(p, base){
    if(!p || !p.variants){ return; }
    for(var i = 0; i < p.variants.length; i++){
      var v = p.variants[i];
      var o = v.options || [];
      if(o[0] === stato.colore && o[1] === stato.filo){
        vai.setAttribute("href", base + "?variant=" + v.id);
        return;
      }
    }
  }

  function disegnaVai(){
    var p = D.prodotti[stato.capo];
    var handle = "sd-" + stato.frase.h + "-" + stato.capo;
    var base = "/products/" + handle;
    vai.setAttribute("href", base);
    vai.textContent = "Vai a " + ARTICOLO[stato.capo] + " — " + p.prezzo + ",00 €";
    if(didasc){ didasc.textContent = p.nome + " " + stato.colore.toLowerCase() + ", ricamo " + stato.filo.toLowerCase() + "."; }

    if(cache[handle]){ scegliVariante(cache[handle], base); return; }
    var mio = ++turno;
    if(!window.fetch){ return; }
    fetch(base + ".js", { headers: { "Accept": "application/json" } })
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(p2){
        if(!p2){ return; }
        cache[handle] = p2;
        if(mio === turno){ scegliVariante(p2, base); }
      })
      .catch(function(){});
  }

  function tutto(){ disegnaCapi(); disegnaColori(); disegnaFili(); disegnaRicamo(); disegnaVai(); }

  selFrase.addEventListener("change", function(){
    var h = selFrase.value;
    for(var i = 0; i < D.frasi.length; i++){ if(D.frasi[i].h === h){ stato.frase = D.frasi[i]; break; } }
    if(stato.capo === "cap" && !stato.frase.cap){ stato.capo = "fel"; stato.colore = null; stato.filo = null; }
    tutto();
  });

  selFrase.value = stato.frase.h;
  if(document.fonts && document.fonts.ready){ document.fonts.ready.then(tutto).catch(tutto); }
  setTimeout(tutto, 1200);
  tutto();
};
